import { useTranslation } from 'react-i18next'

import { CountrySelect } from '@percent/product-nomination-form/ui'
import { Flex, SelectOption } from '@percent/lemonade'
import { useProgress } from '@percent/product-nomination-form/hooks'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'
import { HostedFormStep } from '../../HostedForm.types'
import { Card } from '@percent/product-nomination-form/ui/Card/Card'

export const OrganisationOrigin = () => {
  const { country, setCountry, handleNext } = useValidationStepData()
  const { t } = useTranslation()
  const { progress } = useProgress()

  const onCountryChange = (newValue: SelectOption | null) =>
    setCountry(newValue?.value || '')

  return (
    <Card
      title={t('hostedValidation.title.country')}
      description={t('hostedValidation.title.countrySub')}
      onNext={() => handleNext(HostedFormStep.SELECT_ORGANISATION)}
      nextButtonDisabled={!country}
      progress={progress}
      nextButtonLabel={t('hostedValidation.button.next')}
    >
      <Flex direction="column" gap={16} w="100%">
        <CountrySelect
          placeholder={t('hostedValidation.placeholder.selectCountry')}
          value={country}
          onChange={onCountryChange}
        />
      </Flex>
    </Card>
  )
}
